import { render, staticRenderFns } from "./ListAnoSafra.vue?vue&type=template&id=0f18dbe6"
import script from "./ListAnoSafra.vue?vue&type=script&lang=js"
export * from "./ListAnoSafra.vue?vue&type=script&lang=js"
import style0 from "./ListAnoSafra.vue?vue&type=style&index=0&id=0f18dbe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports